import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const EditIcon = ({
  color = 'foraBlue',
  width = 15,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M1.83 8.724l4.28 4.28-4.084.881c-.054.007-.11.008-.124.006-.078 0-.154-.007-.227-.024-.506-.111-.826-.612-.715-1.116l.87-4.027zM8.268 2.01l4.56 4.56-5.753 5.752-4.56-4.559L8.268 2.01zM9.555.733c1.018-.875 2.53-.873 3.546.006l.148.138.716.716c1.06 1.063 1.057 2.784-.006 3.843l-.31.31-4.558-4.56L9.379.9z"
      />
    </svg>
  </DefaultIconWrapper>
);
